import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/youtube-thumbnail-downloader")({
  component: YoutubeThumbnailLayout,
});

function YoutubeThumbnailLayout() {
  return <Outlet />;
}
